import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    manuales: []
  },
  actions: {
    addDocumentos (context, formData) {      
      return new Promise((resolve, reject) => {
        axios.post('/api/manuals', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteDocumento (context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/manuals/${id}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    getDocumentos ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/manuals')
          .then((response) => {
            commit('setManualesActivosMutation', response.data['hydra:member'])
            resolve(response.data['hydra:member'])
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    getDocumentosOrdenados ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/manuales_ordenados')
          .then((response) => {
            commit('setManualesActivosMutation', response.data)
            resolve(response.data)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    downloadDocumento (context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/manuals/${id}`, {responseType: 'blob'})
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteDocumentos ({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/manuals/${id}`)
          .then((response) => {
            commit('deleteManualesMutation', id) 
            resolve(response)           
          })
          .catch((error) => {  
            reject(error)
          })
      })
    }
  },
  mutations: {
    setManualesActivosMutation (state, manuales) {
      state.manuales = manuales
    },
    deleteManualesMutation (state, id) {
      const idx = state.manuales.findIndex((u) => u.id === id)
      state.manuales.splice(idx, 1)
    }
  },
  modules: {}
})